import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Kontakt, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  public contact: Kontakt = new Kontakt();
  sent = false;

  lat: number = 51.678418;
  lng: number = 7.809007;

  public images: Array<string> = [
    "/assets/images/partners_img/1.jpg",
    "/assets/images/partners_img/2.jpg",
    "/assets/images/partners_img/3.jpg",
    "/assets/images/partners_img/4.jpg",
    "/assets/images/partners_img/5.jpg",
    "/assets/images/partners_img/6.jpg",
    "/assets/images/partners_img/7.jpg",
    "/assets/images/partners_img/8.jpg",
    "/assets/images/partners_img/9.jpg",
    "/assets/images/partners_img/10.jpg",
    "/assets/images/partners_img/11.jpg",
    "/assets/images/partners_img/12.jpg",
    "/assets/images/partners_img/14.jpg",
    "/assets/images/partners_img/15.jpg",
    "/assets/images/partners_img/16.jpg",
    "/assets/images/partners_img/17.jpg",
    "/assets/images/partners_img/18.jpg",
    "/assets/images/partners_img/19.jpg",
    "/assets/images/partners_img/20.jpg",
    "/assets/images/partners_img/21.jpg",
    "/assets/images/partners_img/22.jpg",
    "/assets/images/partners_img/23.jpg",
    "/assets/images/partners_img/24.jpg",
    "/assets/images/partners_img/25.jpg",
    "/assets/images/partners_img/26.jpg",
    "/assets/images/partners_img/27.jpg",
    "/assets/images/partners_img/28.jpg",
    "/assets/images/partners_img/29.jpg",
    "/assets/images/partners_img/30.jpg",
    "/assets/images/partners_img/31.jpg",
    "/assets/images/partners_img/32.png",
    "/assets/images/partners_img/33.png",
    "/assets/images/partners_img/34.png",
    "/assets/images/partners_img/35.png",
    "/assets/images/partners_img/36.jpg",
    "/assets/images/partners_img/37.PNG",
    "/assets/images/partners_img/38.jpg",
    "/assets/images/partners_img/39.png"
  ];

  shuffleArray(array: any[]) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  }

  public numbers: Array<number> = [0, 0, 0];

  constructor(
    private ApiClient: ApiClientService,
    private router: Router
  ) {
    // if (this.router.url == "/pages/home/out") {
    //   localStorage.removeItem('Agroinformer-Current-User');
    // }
    // this.shuffleArray(this.images);
    // this.shuffleArray(this.comments);
  }

  ngOnInit(): void {
    const spinner = document.getElementById('nb-global-spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }

    this.countNumbers(169);
  }

  countNumbers(increaseCount: number) {
    increaseCount--;
    if (increaseCount) {
      setTimeout(() => {
        this.numbers[0] += 2;
        this.numbers[1] += 1;
        this.numbers[2] += 3;
        this.countNumbers(increaseCount);
      }, 100);
    }
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  sendContact() {
    this.ApiClient.kontaktPOST(this.contact)
      .then(() => {
        this.sent = true;
      });
  }

  scrollTo(location: HTMLElement) {
    // console.log(location);
    location.scrollIntoView();
  }

  goToTransport() {
    this.router.navigate(['/dashboard'], { queryParams: { section: 'transport' } });
  }

  goToOffers() {
    this.router.navigate(['/dashboard'], { queryParams: { section: 'ponude' } });
  }

  comments = [{
      person: 'PSVZ Agrovladislavci',
      from: 'Vladislavci, Hrvatska',
      text: 'Ovim putem Vam želim zahvaliti na suradnji. Naša zadruga Agrovladislavci je veoma zadovoljna sa suradnjom. Vaše informacije su nam korisne i brze te nam pomažu u donošenju odluka o što boljoj prodaji robe što nam na kraju donosi zadovoljavajući rezultat. Prema Vašim informacijama znamo kako se ponašati na tržištu i što tražiti. Smatramo da ste hvale vrijedna firma, naše iskustvo u poslovanju s Vama je pozitivno i radujemo se nastavku suradnje.'
    }, {
      person: 'Dem d.o.o. Kulpin',
      from: 'Srbija',
      text: 'Preduzeće Dem d.o.o. Kulpin, iz Srbije ima pšenični mlin, kukuruzni mlin, mešaonu stočne hrane, ekstruder i premiksaru. Naša roba koja ima neosprono dobar kvalitet ne bi mogla otvoriti vrata na teritoriji BiH ukoliko ne bi imali Vašu pomoć. Berzi ima puno, u naših 28 godina poslovanja smo sarađivali sa puno različitih berzi ali malo je onih pravih berzi u koje imate potpuno povjerenje i pruženu ruku u svakom trenutku. Najsrdačnije smo Vam za to zahvalni i nadamo se da ćemo nastaviti sa saradnjom na već ustaljen način. Hvala Vam.'
    }, {
      person: 'Žitosrem a.d. Inđija',
      from: 'Srbija',
      text: 'Sa Agro Informerom saradjujemo dugi niz godina, komunikacija je uvek laka, informacije tačne i brzo se dobijaju. Za svaku preporuku.'
    }, {
      person: 'Vajda-Elvit d.o.o.',
      from: 'Zagreb, Hrvatska',
      text: 'Suradnja sa djelatnicama AgroInformera je uvijek ugodna i produktivna. Prema našem iskustvu maksimalno diskretne i poslovne u odnosu sa svakim korisnikom. Vrlo pozitivno iskustvo, za svaku preporuku!'
    }, {
      person: 'Agro Dom Tim d.o.o.',
      from: 'Crvenka, Srbija',
      text: 'Izuzetno profesionalni, predusretljivi, ljubazni i pre svega pouzdani, tako bih ja u 4 reči opisala Agro Informer berzu informacija.Za mene su pre svega prijatelji pa tek onda drage kolege i saradnici. Moja topla preporuka svim firmama koje se bave agrarnom delatnošću je saradnja sa Agro Informer berzom kao realna potreba prisustva i pristupa tržištu i svakodnevnim oscilacijama.'
    }, {
      person: 'P.Z. Napredak',
      from: 'Županja, Hrvatska',
      text: 'Moramo naglasiti da se do sada, međusobno, vrlo korektno i objektivno informiramo, što vrlo dobro dođe u sagledavanju tržnih cijena, te sadašnjih i budućih kretanja istih.'
    }, {
      person: 'N.T. SH Fauna',
      from: 'Gnjilane, Kosovo',
      text: 'Izuzetna nam je čast što sarađujemo sa kompanijom Agro Informer. Naša saradnja traje već 3 godine i veoma smo zadovoljni uslugom koju nam pružaju. Firma koja pruža tačne podatke u oblasti agrarne delatnosti, ispunjava naše zahteve i što je najvažnije pravovremeno obaveštavaju o skoku ili padu cena na tržištu. Zaista je korisno imati saradnju sa takvom firmom i moja je preporuka za sve firme koje se bave agrarom a trebaju informacije za cene, nemojte se predomišljati, budite saradnik ove firme i bićete zadovoljni za sva vremena. U znak zadovoljstva za saradnju mene ne trebaju pitati za ugovor, nego samo da mi pošalju ugovor za produženje saradnje. Hvalaaa za taj izuzetan tim žena, želim puno uspeha i sreće u budućnosti!'
    }, {
      person: 'A.D. Ratar',
      from: 'Pančevo, Srbija',
      text: 'Sa kompanijom Agro Informer saradjujemo više od godinu dana i veoma smo zadovoljni uslugom koju nam pružaju. Osoblje u kolektivu je vrlo ljubazno, strpljivo i puno razumevanja za ispunjenje naših zahteva. Izveštaje koje dobijamo su adekvatni, ažurni i svakodnevni, što nam pomaže da pravovremeno reagujemo kod skoka ili pada cene proizvoda. Kao potvrdu zadovoljstva saradnje, je i to da smo produžili Ugovor na još godinu dana. Jedno veliko hvala celom timu, i nadam se da će i buduća saradnja biti jednako uspešna kao i ova do sada.'
    }, {
      person: 'Jelena d.o.o.',
      from: 'Kozarska Dubica, BiH',
      text: 'Vi ste najbolje cure na svijetu. Nadam se da ćete ostati dobre i dalje.'
    }, {
      person: 'Dukat d.o.o. Mlin i Pekara',
      from: 'Jelah, BiH',
      text: 'Pravo je olakšanje za naš posao imati podršku kakvu nam vi pružate. Od velike važnosti je imati pouzdane informacije i pouzdane partnere. Vi nam tu značite mnogo.'
    }, {
      person: 'Stojanović i Sin d.o.o. „Mlin Stojanović“',
      from: 'Ruhotina, Bijeljina, BiH',
      text: 'Sa Agro Informerom sarađujemo od samog početka njihovog rada. Sve potrebne informacije u obimu našeg poslovanja dobijam od njih. Saradnja je više nego odlična a često sam na telefonskoj vezi sa vlasnicom Biljanom kada su u pitanju bitnije informacije i saznanja vezana za strane firme sa kojima započinjemo poslovanje. Svi zaposleni u Agro Informeru kao i sama vlasnica se maksimalno trude u svom poslu tako da zaslužuju sve pohvale i dalji vid saradnje.'
    }, {
      person: 'Elen-JTD',
      from: 'Vinica, Makedonija',
      text: 'Saradnja sa Agro Informerom je odlična. Informacije koje dobijamo, kretanje cena i ponude dobavljača, su precizne i brze.'
    }, {
      person: 'T-Team Agrotrade Kft.',
      from: 'Tar, Hungary',
      text: 'Naše višegodišnje iskustvo je, da su ljubazni, uvek tu kad je najbitnije! Uvek imaju prave, bitne i tačne informacije što se tiče tržišta. Samo napred!'
    }, {
      person: 'Fenix Agrar d.o.o.',
      from: 'Ruma, Srbija',
      text: 'Sve pohvale za profesionalni odnos prema poslu, ljubaznost na nivou i dostupnost pravih informacija. Posebna zahvalnost Ani koja je mnogo učinila da i mi budemo još bolji.'
    }, {
      person: 'Gaspetrol d.o.o. (Mlin Velika Greda)',
      from: 'Pančevo, Srbija',
      text: 'Kada je u pitanju saradnja sa vašom berzom, a pre svega svakodnevnim kontaktom sa g-đom Anom, preduzeće Gaspetrol je zahvalno na blagovremenim informacijama o dešavanju na tržištu širom Srbije i van granica. Pre svega, podatke i kontakte koje sam dobila sam iskoristila i svakako su poslužili. Potvrda o tome je i dve godine saradnje, a do nje je i došlo upravo zahvaljujući Ani koja je bila uporna pružajući usluge i pre potpisivanja ugovora.'
    }, {
      person: 'Ma Ko d.o.o.',
      from: 'Sombor, Srbija',
      text: 'Profesionalni, ljubazni, uvek na usluzi. Mnogo korisnih informacija o stanju na tržištu koje nam pomažu pri plasmanu robe.'
    }, {
      person: 'PTP Obrt Baruz',
      from: 'Bobota, Hrvatska',
      text: 'Usluge informisanja o kretanjima na tržištu poljoprivrednih roba koristimo već nekoliko godina. Saradnja sa AgroInformerom pruža uvijek brze i lako dostupne aktualne informacije o ponudi, potražnji, cijenama, dešavanjima iz cijelog regiona. Prava informacija u pravo vrijeme sve više dobija na važnosti u svakodnevnom poslovanju, a to upravo pruža AgroInformer tim. Ostanite i dalje profesionalni, ažurni i precizni.'
    }, {
      person: 'Molaris d.o.o. Kozluk',
      from: 'Zvornik, BiH',
      text: 'U vrijeme kad sve zavisi od pravovremene i tačne informacije AgroInformer je jedan od najboljih servisa te vrste. Sve pohvale za veoma prijatno i predusretljivo osoblje.Visok nivo profesionalnosti u poslovanju.'
    }, {
      person: 'Vinčić d.o.o.',
      from: 'Derventa, BiH',
      text: 'Radeći dugi niz godina sa vama, osim korektne i odlične saradnje stekli smo izuzetno partnerstvo gdje znamo da svaku informaciju koju dobijemo od vas možemo sigurno i provjereno da plasiramo te da na osnovu istih ostvarimo bolju i uspješniju i nabavku i prodaju na terenu. Uspjeli ste da kvalitetno predstavite sve informacije koje su od koristi, a najveća prednost je istinitost podataka i vaša podrška kroz svaku kupovinu ili prodaju. Profesionalnost u svakom smislu. Osim svega navedenog, vaš tim je izuzetno vedar i pozitivan, tako da svaka komunikacija izazove osmijeh na licu. Želimo vam da i u budućnosti zadržite sve vaše kvalitete, mnogo uspjeha i kvalitetan rad!'
    },
    {
      person: 'Božjakovina d.d.',
      from: 'Božjakovina, Hrvatska',
      text: 'Izuzetno smo zadovoljni uslugom koju pružate. Informacije su točne, potpune i prije svega pouzdane. Informacije pristižu redovno na dnevnoj bazi ( ponude i potražnja), te na kraju mjeseca detaljan rezime kroz potpune izvještaje za cijeli mjesec. Smatramo da je cijena pristupačna, te opravdava uslugu u svakom pogledu!'
    },
    {
      person: 'Žitarice d.o.o.',
      from: 'Koprivnica, Hrvatska',
      text: 'Sa firmom Agro Informer radimo već dugo, takoreći od samog osnivanja firme. Mogu reći da sam jako zadovoljan sa njihovim korektnim radom a naravno to nebi bilo moguće da nemaju tako ljubazno osoblje. Sve pohvale!!!'
    },
    {
      person: 'Polina Trade Kft.',
      from: 'Harkany, Hungary',
      text: 'Naša firma Polina Trade Kft. iz Harkanja sa AgroInformerom radi već 6 godina! Jako smo zadovoljni sa suradnjom. Oni su uvjek točni i uvjek nas informiraju novostima sa tržišta. Hvala cure, samo tako nastavite!'
    },
    {
      person: 'Glencore Agriculture',
      from: 'Hungary Kft.',
      text: 'Agro Informer helps us to make new partnerships with Croatian companies. We are truly satisfied with their work.'
    },
    {
      person: 'Agribio SRL',
      from: 'Italia',
      text: 'We are very satisfied with our cooperation with Agroinformer. We have been working together for almost four years and during this time they are helping to us and we have done great jobs. By now AgroInformer convinced me that they are professional company to who I can trust.'
    }];

}
